import { breakpoints } from '../../../styles/theme';
import styled from 'styled-components';
import { OrderPanelStyled } from '../OrderPanelStyled';
import { rem } from 'polished';
import media from '../../../styles/media';

export const OrderPanelStyledAP = styled(OrderPanelStyled)`
    .currencyLabel__suffix--OTR {
        display: none;
    }

    .currencyLabel__suffix--TTC {
        font-size: ${({ theme }) => theme.fontSizes.textTiny};
    }

    &.withShowPriceExcludedVAT {
        .price {
            .currencyLabel__suffix--OTR {
                display: inline;
                font-size: ${rem('8px')};
            }
        }
    }

    .priceSection {
        .deposit {
            max-width: ${rem(200)};

            @media (min-width: ${breakpoints.lg}px) {
                max-width: ${rem(250)};
            }
        }
    }

    .desktopContactSection {
      
        .phoneLink {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.black};
        padding: ${rem('10px')};

        .label {
            font-weight: normal;
        }

        .label,
        .phone {
            font-size: ${rem('12px')};
            white-space: nowrap;
        }
    }
`;
